function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import angular from 'angular';
import { AccesoDatos } from '../../../comun/services/acceso-datos';
var TarjetaBloqueComponentCtrl = /*#__PURE__*/function () {
  TarjetaBloqueComponentCtrl.$inject = ["$log", "NotifService", "AccesoDatos"];
  function TarjetaBloqueComponentCtrl($log, NotifService, AccesoDatos) {
    _classCallCheck(this, TarjetaBloqueComponentCtrl);
    _defineProperty(this, "editar", false);
    this.$log = $log;
    this.NotifService = NotifService;
    this.AccesoDatos = AccesoDatos;
  }
  return _createClass(TarjetaBloqueComponentCtrl, [{
    key: "$onInit",
    value: function $onInit() {
      this.$log.info('[TarjetaBloqueComponentCtrl] onInit');
      this.noactivo = !!this.bloque.data.noactivo;
    }
  }, {
    key: "guardarBloque",
    value: function guardarBloque() {
      var _this = this;
      this.bloque.beforeSave();
      this.AccesoDatos.EdicionFormular_CLIENT.nuevoBloque(this.formular.data.idform, this.bloque).then(function (response) {
        _this.bloque.update(response);
      });
    }
  }, {
    key: "incluirPregunta",
    value: function incluirPregunta() {
      this.onAdd();
    }
  }, {
    key: "upBloqueFormulario",
    value: function upBloqueFormulario() {}
  }, {
    key: "downBloqueFormulario",
    value: function downBloqueFormulario() {}
  }, {
    key: "removeBloqueFormulario",
    value: function removeBloqueFormulario() {
      this.bloque.eliminar = !this.bloque.eliminar;
    }
  }, {
    key: "restoreBloqueFormulario",
    value: function restoreBloqueFormulario() {
      this.bloque.restaurar = !this.bloque.restaurar;
    }
  }, {
    key: "editBloque",
    value: function editBloque() {
      this.editar = true;
    }
  }]);
}();
angular.module('candidato').component('tarjetaBloque', {
  bindings: {
    formular: '<',
    bloque: '<',
    onAdd: '&'
  },
  controller: TarjetaBloqueComponentCtrl,
  template: require('./tarjeta-bloque.component.html')
  //templateUrl: "../../../../app/ui/vs/prog/dev/templates/tarjeta-bloque/tarjeta-bloque.component.html"
});